import { minhasProvas } from './minhasProvas';
import { realizarProvas } from './realizarProvas';

export const alunos = [
  ...minhasProvas,
  ...realizarProvas
];



// WEBPACK FOOTER //
// ./src/routes/prova/alunos/index.js